export const annotationScreenMessagesEn = {
  // Annotation content breadcrumbs
  'annotationContent.breadcrumb.annotatorQueue': 'Encounters',
  'annotationContent.breadcrumb.annotation': 'Encounter-level annotation',

  // Annotation content
  'annotationContent.noteSection.statusChip.pending': 'Pending annotations',
  'annotationContent.noteSection.statusChip.finalized': 'Annotations finalized',
  'annotationContent.noteSection.statusChip.draft': 'Draft',
  'annotationContent.noteSection.statusChip.complete': 'Completed',
  'annotationContent.noteSection.startAnnotationButton': 'Start annotating',
  'annotationContent.noteSection.editAnnotationButton': 'Edit annotations',

  // Annotation config
  'annotationContent.annotationConfig.title.info':
    'For each concept group, select Present (Yes/No). If Yes, select Experienced (Yes/No). If Experienced = Yes, complete the group-specific fields.',

  'annotationContent.annotationConfig.conceptCard.saved': 'Saved x {annotationCount}',
  'annotationContent.annotationConfig.conceptCard.createAnnotationButton': 'Create annotation',

  // Annotation card
  'annotationContent.annotationCard.inProgress': 'In progress',
  'annotationContent.annotationCard.saved': 'Saved',
  'annotationContent.annotationCard.accepted': 'Accepted',
  'annotationContent.annotationCard.rejected': 'Rejected',
  'annotationContent.annotationCard.addedBySupervisor': 'Supervisor',
  'annotationContent.annotationCard.bothAnnotators': 'Both annotators',
  'annotationContent.annotationCard.deleted': 'Deleted',
  // Saved annotation card

  // In progress annotation card
  'annotationContent.annotationConfig.evidenceNotRequiredWhenPresent':
    'Evidence not required when Present = no',
  'annotationContent.annotationConfig.evidenceRequiredWhenPresent':
    'Evidence is required when Present = Yes',
  'annotationContent.annotationConfig.supportedIndirectly.label': 'Supported indirectly',

  // Mark not present modal
  'annotationContent.markNotPresentModal.title': 'Mark remaining as Not Present',
  'annotationContent.markNotPresentModal.unSavedAnnotations.title': 'Unsaved annotations',
  'annotationContent.markNotPresentModal.description':
    "This will save Present = No for the concepts below that don't yet have a saved annotation.",
  'annotationContent.markNotPresentModal.confirmButton': 'Confirm',
  'annotationContent.markNotPresentModal.cancelButton': 'Cancel',
  'annotationContent.markNotPresentModal.unsavedAnnotations.description':
    'You have unsaved annotations in following concepts:',
  'annotationContent.markNotPresentModal.unsavedAnnotations.description2':
    'Please save or discard them before proceeding',
  'annotationContent.markNotPresentModal.unsavedAnnotations.okButton': 'Ok',

  // Annotation config footer buttons
  'annotationContent.annotationConfig.markRemainingNotPresentButton':
    'Mark remaining as not present ({conceptCount})',
  'annotationContent.annotationConfig.markRemainingNotPresentButton.description':
    'Are you sure you want to mark the remaining concepts as not present?',
  'annotationContent.annotationConfig.markRemainingNotPresent.pendingMsg':
    'Marking remaining concepts as not present...',
  'annotationContent.annotationConfig.finaliseEncounterButton': 'Finalize encounter',

  // Finalized annotation modal
  'annotationContent.finalizedAnnotationModal.title': 'Finalize encounter annotations',
  'annotationContent.finalizedAnnotationModal.description':
    'Are you sure you want to finalize the annotations for this encounter?',
  'annotationContent.finalizedAnnotationModal.finalizingMessage': 'Finalizing annotations...',
  'annotationContent.finalizedAnnotationModal.confirmButton': 'Finalize annotations',
  'annotationContent.finalizedAnnotationModal.cancelButton': 'Cancel',

  // Confirm delete annotation modal
  'annotationContent.confirmDeleteAnnotationModal.title': 'Delete annotation',
  'annotationContent.confirmDeleteAnnotationModal.warning.title': 'Confirm delete',
  'annotationContent.confirmDeleteAnnotationModal.warning': 'This action cannot be undone.',
  'annotationContent.confirmDeleteAnnotationModal.description.prefix':
    'This action will permanently delete',
  'annotationContent.confirmDeleteAnnotationModal.loadingMessage': 'Deleting annotation...',
  'annotationContent.confirmDeleteAnnotationModal.confirmButton': 'Delete annotation',
  'annotationContent.confirmDeleteAnnotationModal.cancelButton': 'Cancel',
};
